{
  "COMMON": {
    "ACTION_LABELS": {
      "BACK": "Back"
    },
    "ORDERS": {
      "AGREE_TO_PURCHASE": "Agree to purchase",
      "PURCHASE": "Purchase",
      "PAYMENT": "Payment",
      "DECLINE": "Decline",
      "DRAFT_ORDER": "Save as draft",
      "NO_LONGER_AVAILABLE": "This order can't be altered. For more info, please contact your sales representative.",
      "ORDER_FORM_LABEL": "Order form",
      "PRICING": "Pricing",
      "PRINT": "Print",
      "REVIEW": "Review order",
      "UPDATE_ORDER_FORM_ANSWERS": "Update order form answers",
      "LOGIN": "Log in",
      "ERROR": "Error",
      "ERROR_LOADING_MESSAGE": "We were unable to load this order",
      "ERROR_AT_LEAST_ONE_LINE_ITEM": "Order must have at least 1 line item. Please add an item.",
      "SUBMIT_ORDER": "Submit order",
      "SUBMIT_FOR_CUSTOMER_APPROVAL": "Submit for customer approval",
      "RESUBMIT_FOR_CUSTOMER_APPROVAL": "Resubmit for customer approval",
      "CONVERT_TO_DRAFT": "Convert to draft",
      "CANCEL_ORDER": "Cancel order",
      "UNSUBSCRIBE_FROM_ORDER": "Unsubscribe from update notifications",
      "SUBSCRIBE_TO_ORDER": "Subscribe to update notifications",
      "TRY_AGAIN": "Try again",
      "TERMS_OF_SERVICE_ERROR": "You must agree to the Terms of Service to continue.",
      "ORDER_FORM_ERROR": "Some of the required fields aren't filled out. Update those and try again.",
      "PAYMENT_METHOD_ERROR": "A valid payment method is required.",
      "ERROR_CUSTOM_PRICE": "We could not update the amount. Please try again.",
      "SUCCESS_CUSTOM_PRICE": "Successfully updated the amount",
      "EDIT": "Edit",
      "ADD": "Add",
      "CANCEL": "Cancel",
      "UPLOAD": "Upload",
      "REQUIRED": "Required",
      "ERROR_LESS_THAN_ONE": "Must be 1 or greater",
      "ORDER_SUMMARY": "Order Summary",
      "INVALID_CARD_ERROR": "Invalid credit card details.",
      "INVALID_USER_SIGNATURE_ERROR": "A signature is required."
    },
    "EDIT_ORDERS": {
      "FULFILLMENT_TITLE": "Fulfillment orders",
      "VIEW_LINK": "View",
      "DETAILS_NEEDED_BANNER": "Details Needed",
      "DETAILS_NEEDED_BANNER_DESCRIPTION": "Fulfillment form information is required for an item",
      "VIEW_FORMS": "View forms"
    },
    "ORDER_DETAILS": {
      "TITLE": "Order details",
      "COMPANY": "Company",
      "ADDRESS": "Address",
      "COMPANY_AND_ADDRESS": "Company & Address",
      "COMPANY_NAME_AND_ADDRESS": "Company name and address",
      "CONTRACT_START": "Contract Start",
      "CONTRACT_DURATION": "Contract Duration",
      "CONTRACT_START_UPDATE_ERROR": "Failed to update contract start date.",
      "CONTRACT_DURATION_UPDATE_ERROR": "Failed to update contract duration.",
      "NO_CONTRACT_DURATION": "No contract length",
      "LENGTH": "Length",
      "FREQUENCY": "Frequency",
      "CUSTOMER_NOTES_TITLE": "Customer notes",
      "CUSTOMER_NOTES_INFO": "These notes will be visible to the customer.",
      "ADMINISTRATIVE_NOTES_TITLE": "Administrator notes",
      "ADMINISTRATIVE_NOTES_INFO": "These notes will be hidden from the customer, and only visible to admins and salespeople.",
      "EMPTY_NOTES": "No notes added",
      "NOTES_UPDATE_ERROR": "Failed to update notes.",
      "ATTACHMENTS": "Attachments",
      "UPLOAD_ATTACHMENTS": "Upload attachments",
      "EMPTY_ATTACHMENTS": "No files added",
      "SUCCESSFUL_UPLOAD": "Successfully uploaded {{numberFilesUploaded}} file(s)",
      "SUBMITTED_BY": "Submitted by:",
      "TAGS": "Tags",
      "EMPTY_TAGS": "No tags added",
      "NEW_TAG": "Add {{newTag}} as a new tag",
      "TAGS_UPDATE_ERROR": "Your tags couldn't be updated. Please try again.",
      "CONTRACT_DURATIONS": {
        "DAY": "day(s)",
        "WEEK": "week(s)",
        "MONTH": "month(s)",
        "YEAR": "year(s)"
      }
    },
    "ORDER_CURRENCY": {
      "TITLE": "Order Currency",
      "DESCRIPTION": "Optionally override the currency on the order. You must manually update the prices on the order items to reflect the chosen currency.",
      "VMF_ONLY_BADGE": "VMF ONLY",
      "DEFAULT_OPTION": "Default"
    },
    "LINE_ITEMS": {
      "TITLE": "Order Contents",
      "ITEM": "Item",
      "QUANTITY": "Quantity",
      "UNIT_PRICE": "Unit Price",
      "DISCOUNT": "Discount",
      "FREQUENCY": "Frequency",
      "REMOVE": "Remove item",
      "ADD": "Add items",
      "ADD_ROW": "Add row",
      "REMOVE_ROW": "Remove row",
      "GREATER_THAN_ZERO": "Must be greater than 0",
      "EDITION": "Edition",
      "EDITION_REQUIRED_FOR_PRICE": "Edition required to set price",
      "QUANTITY_DISABLED": "You can only activate one of these at a time",
      "REVENUE_REQUIRED": "Price is required",
      "GREATER_THAN_OR_EQUAL_TO_ZERO": "Must be greater than or equal to zero",
      "MUST_BE_NUM": "Must be a number",
      "FREQUENCY_REQUIRED": "Frequency is required"
    },
    "ACTIVITY": {
      "TITLE": "Activity",
      "CREATED_BY": "Created by {{name}}"
    },
    "SUMMARY": {
      "TITLE": "Retail Summary"
    },
    "ORDER_SUBMITTED": {
      "ORDER_SUBMITTED": "Order submitted",
      "RECEIVE_CONFIRMATION_SHORTLY": "Thank you for your order, it will be processed shortly.",
      "ITEM_HAS_FULFILLMENT_FORM": "Some items may require additional information from you or your client before they can be fulfilled.",
      "VIEW_ACCOUNT_DETAILS": "View account details",
      "SUCCESS": "Success!",
      "ORDER_HAS_BEEN_RECEIVED": "Your order has been received.",
      "FULFILLMENT_FORMS": "Fulfillment forms",
      "FULFILLMENT_FORMS_SUBTITLE": "The forms below will need to get completed before fulfillment can begin",
      "BACK_TO_ACCOUNT": "Back to account",
      "VIEW_ORDER": "View order"
    }
  },
  "FULFILLMENT": {
    "TITLE": "Fulfillment",
    "SUBTITLE": "Some products have Task Manager projects tied to them. These are available at no extra cost.",
    "SERVICE_PROVIDER": "Service Provider",
    "PRODUCTS": "Products",
    "PROJECT_NAME": "Project Name",
    "YOU": "You",
    "LEARN_MORE": "Learn more",
    "LEARN_MORE_DIALOG": {
      "TITLE": "Fulfillment projects",
      "DESCRIPTION_LINE_1": "Your Vendasta subscription includes access to Task Manager. This tool allows you to track and fulfill services on behalf of your clients all in one place.",
      "DESCRIPTION_LINE_2": "Some of the products in this order have a corresponding Task Manager project available. These projects come in two flavors, depending on who is set to fulfill them",
      "SERVICE_PROVIDER_TITLE": "You're the service provider",
      "SERVICE_PROVIDER_DESCRIPTION": "Projects give you guidance on how to fulfill on those services, so even if you aren't familiar with the product, you can assist your customer.",
      "NOT_SERVICE_PROVIDER_TITLE": "You're not the service provider",
      "NOT_SERVICE_PROVIDER_DESCRIPTION": "You can track the progress of these projects in Task Manager, allowing you to provide meaningful status updates to your clients."
    },
    "PROJECTS": "Projects",
    "FULFILLMENT_FORMS": "Fulfillment forms",
    "SHARE": "Share"
  },
  "SALES_ORDERS": {
    "ORDERS": "Orders"
  }
}
